import React, { useEffect, useState } from 'react'
import { Container, MachineItem, MachineList, Title } from './style'
import axios from 'axios'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { ProductionOutletType } from '../../pages/ClientPanel/ProductionFlow'
import { OpViewerType } from '../Modals/ViewPCP'

interface PropsType {
  op: OpViewerType
}

const MiniScreenForSelects:React.FC<PropsType> = ({op}) => {
  const [ machines, setMachines ] = useState<{id:number}[]>([])
  const navigate = useNavigate()
  
  useEffect(() => {
    if(op.nextStageId) {
      axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/pcp/machines`, {
        params:{
          stageId:op.nextStageId
        }
      })
        .then(response => {
          setMachines(response.data)
        })
        .catch(error => 
          console.error(error)
        )
    }
  }, [op.nextStageId])

  const selectMachineByClick = (machineId:number) => {
    axios.patch(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/pcp/service/${op.id}`, {
      machineId:Number(machineId),
      currentStageId: op.currentStageId
    })
    .then((response) => {
      if(response.data) navigate('..')
    })
    .catch((error) => {
      console.error(error)
    })
  }
  
  return(
    <Container>
      <Title>Qual máquina?</Title>
      <MachineList>
        {machines.map((item, index) =>
          <MachineItem onClick={() => selectMachineByClick(item.id)} key={index}>{item.id}</MachineItem>
        )}
      </MachineList>
    </Container>
  )
}

export default MiniScreenForSelects